require("./beneficiaryNGO.scss");

// @vendors
import React, {Component, Fragment} from "react";
import PropTypes from "prop-types";
// @components
import {OKAutosuggest} from "commonsComponents/OKAutosuggest";
import {NGOModalSearcher} from "components/ngoModalSearcher/ngoModalSearcher";
// @common-components
import {OKCheckbox} from "commonsComponents/OKCheckbox";
import {InputSafe} from "commonsComponents/inputSafe";
import {OKButton} from "commonsComponents/OKButton";
import OKModal from "commonsComponents/OKModal";
import OkNgoSearcher from "okNGOSelector/okNgoSearcher/okNgoSearcher";
const {LoadingSection} = require('commonsComponents/loadingSection');
// @actions
const transferActions = require('actions/transferActions');
// @utils
import {i18n} from "core/i18n";
// @constants
import {NGO_MODAL_TRANSFER} from 'constants/index';

const { connect } = require ('react-redux');
const storage = require("utilities/storage");

const ngoActionRetriever = require('actions/ngoRetriever');

const { DEFAULT_COUNTRY } = require("constants/index");
const {COUNTRIES_CODES} = require('constants/countries');

const environmentConfig = require('core/environmentConfig');

const usd = require('utilities/usd');
const { FormattedText, formatText, hasTranslation } = i18n;
const {
    recordLink,
    PROC_ONG_SEARCHER,
    PROC_ONG_RESULT_CLICK
} = require("utilities/tagging");

const {
    TRANSFER
} = require('constants/ngoCategoryContexts');

const {
    EMPTY_CONCEPT
} = require('constants/index');

class BeneficiaryNGO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alias:
                props &&
                props.immBeneficiaryNew &&
                props.immBeneficiaryNew.get("alias") &&
                props.immBeneficiaryNew.get("alias"),
            charityFoundations: [],
            charityFoundationsError: false,
            charityFoundationsSource: [],
            charityFoundationsSourceError: false,
            openModalNGO: false,
            suggestionPassport: null
        };
    }

    componentDidMount() {
        const context = TRANSFER;
        const {originCountry, retrieveNgoList} = this.props;
        retrieveNgoList(originCountry, context);
    }

    componentDidUpdate(preProvs) {
        if (preProvs.immNgoListRetrieved.get('retrievedList') !== this.props.immNgoListRetrieved.get('retrievedList')) {
            this.setState({
                charityFoundationsSource: 
                this.props.immNgoListRetrieved.get('retrievedList').toJSON()
                    .map(n=>Object.assign({showNotDeductibleMessage: false},n))
            });
        }
        
        if (this.state.charityFoundations.length > 0) {
            const charityFoundation = this.state.charityFoundations[0];
            const proxiedCharityDescription = this.getCharityFoundationUniqueNameWithoutCountryCode(charityFoundation);
            const charityDescription = hasTranslation(`ngoDescriptionModal-${proxiedCharityDescription}`)
                ? formatText(`ngoDescriptionModal-${proxiedCharityDescription}`)
                : EMPTY_CONCEPT;
            preProvs.setConcept(charityDescription);
        }
    }

    handleOnBlur = () => {
        if (this.state.charityFoundations.length <= 0) {
            this.props.actions.handleSetNGOValidity(false);
        }
    };

    openModalNGO = () => {
        this.setState({
            openModalNGO: true
        });
    };

    changePassportNGO = item => {
        let suggestionNgo = null;

        if (item.length > 0) {
            suggestionNgo = {
                suggestion: {
                    name: item[0].name,
                    deductible: item[0].deductible,
                    iban: item[0].iban,
                    uniquename: item[0].uniquename
                }
            };
        }

        this.setState({
            suggestionPassport: suggestionNgo
        });
    };

    handleSelectCharityFoundation = (charityFoundation, selectedValue = "") => {
        const { actions, getBankNameFromIban, handleBeneficiary } = this.props;
        actions.setBeneficiaryName(charityFoundation.suggestion.name);
        actions.setNotDeductibleNGOMessage(
            !charityFoundation.suggestion.deductible
        );
        getBankNameFromIban(charityFoundation.suggestion.iban);
        actions.setBeneficiaryIban(charityFoundation.suggestion.iban, true);
        handleBeneficiary(charityFoundation.suggestion.iban);
        recordLink(
            PROC_ONG_SEARCHER,
            PROC_ONG_RESULT_CLICK + charityFoundation.suggestion.name,
            selectedValue
        );

        this.setState(
            {
                openModalNGO: false,
                charityFoundations: [charityFoundation]
            },
            () => this.props.actions.handleSetNGOValidity(true)
        );
    };

    handleEditCharityFoundation = (ngoId, name) => {
        this.props.actions.setBeneficiaryName("");
        this.props.actions.setBeneficiaryIban("", false);
        recordLink("interaccion en ONGs", "eliminar ONG seleccionada ", name);

        this.setState(
            {
                suggestionPassport: null,
                charityFoundations: [
                    ...this.state.charityFoundations.filter(
                        charityFoundation =>
                            charityFoundation.suggestion.ngoId !== ngoId
                    )
                ]
            },
            () => this.props.actions.handleSetNGOValidity(true)
        );
    };

    isAliasRepeated = alias => {
        const { immBeneficiaries } = this.props;

        return immBeneficiaries
            .get("byOrder")
            .some(
                beneficiaryId =>
                    immBeneficiaries
                        .getIn(["byId", beneficiaryId, "alias"])
                        .toLowerCase() === alias.toLowerCase()
            );
    };

    handleAliasBlur = event => {
        const alias = event.target.value.trim();
        const isValid = Boolean(alias) && !this.isAliasRepeated(alias);
        this.setState(
            {
                alias: alias
            },
            () => {
                this.props.actions.setBeneficiaryAlias(alias, isValid);
            }
        );
    };

    handleAliasChange = event => {
        this.setState({
            alias: event.target.value
        });
    };

    changeModalState = openModalNGO => {
        this.setState({
            openModalNGO
        });
    };

    handleModalClose = () => {
        this.setState({
            openModalNGO: false
        });
    };

    renderNoSuggestion = () => {
        return <FormattedText value={"ngoSearcher-noSuggestion"} />;
    };

    renderButtonNoSuggestion = () => {
        return <FormattedText value={"ngoModal-buttonModalErrorSuggestion"} />;
    };

    buildButton = () => {
        return (
            <OKButton
                modifier="link-emphasize"
                size="small"
                onClick={() => this.changeModalState(true)}
            >
                <FormattedText value={"ngoModal-buttonModal"} />
            </OKButton>
        );
    };

    buildModalNGOs = () => {
        const {
            openModalNGO,
            charityFoundationsSource,
            suggestionPassport
        } = this.state;
        const { originCountry } = this.props;
        const interactionId = usd.getInteractionId();

        let isDisabled = true;
        if (suggestionPassport) {
            isDisabled = false;
        }

        if (originCountry === DEFAULT_COUNTRY) {
            return (
                <NGOModalSearcher
                    changeCharityFoundation={this.handleSelectCharityFoundation}
                    typeNGOModal={NGO_MODAL_TRANSFER}
                    openModal={openModalNGO}
                    closeModal={this.changeModalState}
                    charityFoundations={charityFoundationsSource}
                />
            );
        } else {
            const token = storage.cookies.get("tokenCredential");
            return (
                <OKModal
                    onCloseCallback={this.handleModalClose}
                    size="large"
                    overlayClassName="ngo-selector__modal"
                    contentOverflow="auto"
                    contentFooter={
                        <div className="ngo-selector__button-container">
                            <OKButton
                                disabled={isDisabled}
                                onClick={() => {
                                    this.handleSelectCharityFoundation(
                                        this.state.suggestionPassport
                                    );
                                }}
                            >
                                <FormattedText value="ngosSelector-modalButton" />
                            </OKButton>
                        </div>
                    }
                    isOpen={openModalNGO}
                    content={
                        <OkNgoSearcher
                            country={originCountry}
                            onClickCallBack={this.changePassportNGO}
                            formatText={formatText}
                            FormattedText={FormattedText}
                            userToken={token}
                            maxSelection={3}
                            isContactCenter={__CONTACT_CENTER__}
                            environmentConfig={environmentConfig.baseHost}
                            interactionId={interactionId}
                            deleteLastOneOption={true}
                            context={TRANSFER}
                        />
                    }
                ></OKModal>
            );
        }
    };

    getCharityFoundationUniqueNameWithoutCountryCode = (charityFoundation) => {
        const countryCodes = Object.values(COUNTRIES_CODES) || [];
        let uniqueName = charityFoundation.suggestion && charityFoundation.suggestion.uniquename || '';
        const charityUniqueNameHasCountryCode = !!countryCodes.find(c => `_${c}` === uniqueName.slice(-3));
        uniqueName = uniqueName.replace(/_/g, "") || ''

        return charityUniqueNameHasCountryCode
            ? uniqueName.substr(0, uniqueName.length - 2)
            : uniqueName;
    };

    getErrorMessageFromErrorType = (aliasRequired, aliasRepited) => {
        let labelAlias = formatText('transferSummary-step1BeneficiaryAlias');
        let beneficiaryRequiredText = formatText('transferSummary-requiredMessage', [labelAlias]);
        let aliasRepitedText = formatText('transferSummary-step1AliasRepeated');

        return (aliasRepited && aliasRepitedText) || (aliasRequired && beneficiaryRequiredText);
    };

    resolveContentInFunctionIfAlreadyFetchOrNot = () => {
        let content;
        if(this.state.charityFoundationsSource.length === 0) {
           content = this.buildLoadingSection();
        } else {
            content = this.buildAutoSuggestContentRegion();
        }
        return content;
    };

    buildLoadingSection = () => {
        const contentLoading =  (<Fragment><LoadingSection/></Fragment>);
        return contentLoading;
    };

    buildAutoSuggestContentRegion = () => {
        const contentAutoSuggest = (
            <Fragment>
                <OKAutosuggest
                    dataset={this.state.charityFoundationsSource}
                    maxItems="5"
                    content="name"
                    format="text"
                    widthInput="big"
                    datasetKey="name"
                    placeholder={formatText("ngoSearcher-placeholder")}
                    noSuggestionComponent={this.renderNoSuggestion()}
                    buttonNoSuggestionComponent={this.renderButtonNoSuggestion()}
                    handleOnError={this.openModalNGO}
                    onSelect={this.handleSelectCharityFoundation}
                />
                {this.buildButton()}
                {this.buildModalNGOs()}
            </Fragment>
        );
        return contentAutoSuggest;
    };

    render() {
        //if still doesnt have the response doesnt need to render anything yet
        const charityFoundation = this.state.charityFoundations[0];
        const { actions, immBeneficiaryNew } = this.props;
        const { alias } = this.state;

        const aliasRequiredAlertVisible =
            immBeneficiaryNew.get("aliasIsDirty") &&
            immBeneficiaryNew.get("alias") === "";
        const aliasRepeatedAlertVisible =
            immBeneficiaryNew.get("aliasIsDirty") &&
            !immBeneficiaryNew.get("aliasIsValid") &&
            immBeneficiaryNew.get("alias") !== "";
        const isEditingBeneficiaryExisting = immBeneficiaryNew.get(
            "isEditingBeneficiaryExisting"
        );
        const addBeneficiary = immBeneficiaryNew.get("addBeneficiary");
        const errorMessageText = this.getErrorMessageFromErrorType(aliasRequiredAlertVisible, aliasRepeatedAlertVisible);
        let content = this.resolveContentInFunctionIfAlreadyFetchOrNot();

        if (this.state.charityFoundations.length > 0) {
            const proxiedCharityDescription = this.getCharityFoundationUniqueNameWithoutCountryCode(charityFoundation);
            const charityDescription = hasTranslation('ngoDescriptionModal-'+proxiedCharityDescription)
                ? formatText(`ngoDescriptionModal-${proxiedCharityDescription}`)
                : EMPTY_CONCEPT;
            content = (
                <Fragment>
                    <div className="hire-select-account__ngo-image-selected">
                        <div
                            onClick={() =>
                                this.handleEditCharityFoundation(
                                    charityFoundation.suggestion.ngoId,
                                    charityFoundation.suggestion.name
                                )
                            }
                            className="hire-select-account__delete-image-selected"
                        >
                            <FormattedText
                                value="configCustomItem-edit"
                                className="hire-select-account__delete-image-selected-text"
                            />
                        </div>
                        <div className="transfer-beneficiary-ngo__text--isolated transfer-beneficiary-ngo__text--bold">
                            {charityFoundation.suggestion.name}
                        </div>
                        <div>
                            IBAN:{" "}
                            <span className="transfer-beneficiary-ngo__text--bold">
                                {charityFoundation.suggestion.iban}
                            </span>
                        </div>
                        <div className="transfer-beneficiary-ngo__ong-description">
                            <FormattedText value="transferSummary-transferSummary_descriptionConcept" />:{" "}
                            <span className="transfer-beneficiary-ngo__text--bold">
                                {charityDescription}
                            </span>
                        </div>
                    </div>
                    <OKCheckbox
                        idName="chk_TransferStep1_AddBeneficiary"
                        value={addBeneficiary}
                        onChange={actions.handleAddBeneficiary}
                        label={
                            <FormattedText value="transferSummary-step1AddBeneficiary" />
                        }
                        extraClass="transfer-beneficiary-ngo__checkbox"
                    />
                    {addBeneficiary && (
                        <div style={{ marginTop: "10px" }}>
                            <InputSafe
                                id={"inp_TransferStep1_BeneficiaryAlias"}
                                label={
                                    <FormattedText value="transferSummary-step1BeneficiaryAlias" />
                                }
                                type="text"
                                autoComplete="off"
                                value={alias}
                                onChange={this.handleAliasChange}
                                onBlur={this.handleAliasBlur}
                                errorState={
                                    aliasRequiredAlertVisible ||
                                    aliasRepeatedAlertVisible
                                }
                                errorMessage={errorMessageText} 
                                maxLength="50"
                                disabled={isEditingBeneficiaryExisting}
                            />
                        </div>
                    )}
                </Fragment>
            );
        }

        return (
            <div className="transfer-beneficiary-ngo__container">{content}</div>
        );
    }
}

BeneficiaryNGO.propTypes = {
    actions: PropTypes.object,
    immBankEntity: PropTypes.object,
    immBeneficiaries: PropTypes.object,
    immBeneficiaryNew: PropTypes.object,
    isEditingScheduled: PropTypes.bool,
    isNGOValid: PropTypes.bool.isRequired,
    isReusingTransfer: PropTypes.bool,
    getBankNameFromIban: PropTypes.func.isRequired,
    handleBeneficiary: PropTypes.func.isRequired,
    localHandleSetNGOValidity: PropTypes.func.isRequired,
    originCountry: PropTypes.string,
    immNgoListRetrieved: PropTypes.object,
    retrieveNgoList: PropTypes.func
};


module.exports = connect(
    state => ( {
        originCountry: state.profile.get('originCountry'),
        immNgoListRetrieved: state.ngoRetrieveList
    }),
    {
        retrieveNgoList:  ngoActionRetriever.requestNgoList,
        setConcept: transferActions.setConcept,
    }
    )(BeneficiaryNGO);
